module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Live Quiz'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Live Quiz")]), _vm._v(" "), _c('v-card', [_c('v-autocomplete', {
    staticClass: "select_box mx-2 my-2 pt-5",
    attrs: {
      "id": "select_teacher",
      "items": _vm.teachers,
      "item-text": "name",
      "item-value": "id",
      "height": "36px",
      "placeholder": "Pilih Guru",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.chooseTeacher(_vm.teacher)
      }
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'mt-5 ml-2' : ''
  }, [(_vm.$vuetify.breakpoint.mdAndUp) ? _c('v-btn', {
    attrs: {
      "height": "40",
      "rounded": "",
      "depressed": "",
      "color": "touchblue"
    },
    on: {
      "click": function($event) {
        _vm.dialogDate = true
      }
    }
  }, [_c('span', {
    staticClass: "blew--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "blew",
      "small": ""
    }
  }, [_vm._v("mdi-calendar-today")]), _vm._v("\n                     \n                    " + _vm._s(_vm.moment(_vm.selectedDay).format("MMM DD, YYYY")) + "\n                     \n                    "), _c('v-icon', {
    attrs: {
      "color": "blew",
      "small": ""
    }
  }, [_vm._v(" mdi-chevron-down ")])], 1)]) : _c('v-btn', {
    attrs: {
      "depressed": "",
      "block": "",
      "tile": "",
      "color": "touchblue"
    },
    on: {
      "click": function($event) {
        _vm.dialogDate = true
      }
    }
  }, [_c('div', {
    staticClass: "d-flex align-center blew--text"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('v-icon', {
    attrs: {
      "color": "blew",
      "small": ""
    }
  }, [_vm._v("\n                            mdi-calendar-today\n                        ")]), _vm._v("\n                         \n                        " + _vm._s(_vm.moment(_vm.selectedDay).format("MMM DD, YYYY")) + "\n                    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('v-icon', {
    attrs: {
      "color": "blew",
      "small": ""
    }
  }, [_vm._v("\n                            mdi-chevron-down\n                        ")])], 1)], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "320"
    },
    on: {
      "click:outside": function($event) {
        _vm.nowday = _vm.selectedDay
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.nowday = _vm.selectedDay
      }
    },
    model: {
      value: (_vm.dialogDate),
      callback: function($$v) {
        _vm.dialogDate = $$v
      },
      expression: "dialogDate"
    }
  }, [_c('v-card', [_c('v-date-picker', {
    attrs: {
      "no-title": "",
      "full-width": "",
      "color": "primary",
      "weekday-format": _vm.getDay,
      "show-current": _vm.moment().format('YYYY-MM-DD'),
      "locale": "id",
      "first-day-of-week": "1",
      "prev-icon": "mdi-chevron-left",
      "next-icon": "mdi-chevron-right"
    },
    model: {
      value: (_vm.nowday),
      callback: function($$v) {
        _vm.nowday = $$v
      },
      expression: "nowday"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "darkerfadedblue",
      "text": "",
      "rounded": "",
      "block": "",
      "large": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        ((_vm.nowday = _vm.selectedDay),
          (_vm.dialogDate = false))
      }
    }
  }, [_vm._v("Batal")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "block": "",
      "large": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        ((_vm.selectedDay = _vm.nowday),
          (_vm.dialogDate = false))
      }
    }
  }, [_vm._v("Terapkan")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'mt-5' : '',
    attrs: {
      "outlined": "",
      "tile": _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-card-text', {
    class: _vm.$vuetify.breakpoint.smAndDown ? ' pa-0' : 'py-1'
  }, [_c('v-carousel', {
    attrs: {
      "height": "100%",
      "light": "",
      "next-icon": "mdi-chevron-right",
      "prev-icon": "mdi-chevron-left",
      "hide-delimiter-background": "",
      "hide-delimiters": "",
      "show-arrows": _vm.$vuetify.breakpoint.mdAndUp,
      "touchless": ""
    },
    scopedSlots: _vm._u([{
      key: "prev",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "fab": "",
            "depressed": "",
            "small": "",
            "color": "#f4f9f9",
            "width": "24",
            "height": "24"
          },
          on: {
            "click": function($event) {
              ((_vm.startweek = _vm.moment(_vm.startweek).subtract(
                  1,
                  'week'
                )),
                _vm.keyaweek++)
            }
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v(" mdi-chevron-left")])], 1)]
      }
    }, {
      key: "next",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "fab": "",
            "small": "",
            "depressed": "",
            "color": "#f4f9f9",
            "width": "24",
            "height": "24"
          },
          on: {
            "click": function($event) {
              ((_vm.startweek = _vm.moment(_vm.startweek).add(
                  1,
                  'week'
                )),
                _vm.keyaweek++)
            }
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v(" mdi-chevron-right")])], 1)]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _vm._l((1), function(left, i) {
    return _c('v-carousel-item', {
      key: i
    }, [_c('transition', {
      attrs: {
        "name": "scroll-x-transition",
        "mode": "out-in"
      }
    }, [_c('v-item-group', {
      directives: [{
        name: "touch",
        rawName: "v-touch",
        value: ({
          left: function () { return _vm.swipe(0); },
          right: function () { return _vm.swipe(1); },
        }),
        expression: "{\n                                    left: () => swipe(0),\n                                    right: () => swipe(1),\n                                }"
      }],
      key: _vm.keyaweek,
      attrs: {
        "mandatory": ""
      }
    }, [_c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-row', {
      staticClass: "no-gutters"
    }, _vm._l((_vm.aweek), function(n, i) {
      return _c('v-col', {
        key: i,
        class: _vm.$vuetify.breakpoint.mdAndUp ?
          'mx-5' :
          'mx-0'
      }, [_c('v-item', {
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(ref) {
            var toggle = ref.toggle;

            return [_c('v-card', {
              staticClass: "d-flex mx-auto flex-column text-center",
              attrs: {
                "color": _vm.selectedDay == n ?
                  'blew' :
                  'transparent',
                "flat": "",
                "width": _vm.$vuetify.breakpoint
                  .smAndDown ?
                  '' :
                  '70',
                "height": "50"
              },
              on: {
                "click": function($event) {
                  (toggle,
                    (_vm.selectedDay = n))
                }
              }
            }, [_c('div', {
              staticClass: "my-auto"
            }, [_c('div', {
              staticClass: "roboto-text font-weight-500 text-center",
              class: _vm.selectedDay ==
                n ?
                'white--text' :
                'fadedblue--text',
              staticStyle: {
                "font-size": "14px"
              },
              style: (_vm.$vuetify
                .breakpoint
                .smAndDown ?
                ' font-size: 10px' :
                ' font-size: 14px')
            }, [_vm._v("\n                                                            " + _vm._s(_vm.moment(
              n
            ).format(
              "dddd"
            )) + "\n                                                        ")]), _vm._v(" "), _c('div', {
              staticClass: "roboto-text font-weight-700 text-center",
              class: _vm.selectedDay ==
                n ?
                'white--text' :
                'grey2--text',
              style: (_vm.$vuetify
                .breakpoint
                .smAndDown ?
                ' font-size: 14px' :
                ' font-size: 18px')
            }, [_vm._v("\n                                                            " + _vm._s(_vm.moment(
              n
            ).format(
              "DD"
            )) + "\n                                                        ")])])])]
          }
        }], null, true)
      })], 1)
    }), 1)], 1)], 1)], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "border-top-1 pa-1"
  }, [_c('v-sheet', {
    staticClass: "timeline-class",
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "hidden"
    },
    attrs: {
      "height": "70vh",
      "width": "100%"
    }
  }, [_c('v-fade-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('div', [_c('v-timeline', {
    staticStyle: {
      "min-height": "100%"
    },
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, _vm._l((3), function(index) {
    return _c('v-timeline-item', {
      key: index,
      attrs: {
        "color": 'fadedblue',
        "fill-dot": "",
        "icon": "mdi-circle-outline",
        "small": ""
      },
      scopedSlots: _vm._u([{
        key: "opposite",
        fn: function() {
          return [_c('span', {
            staticClass: "font-weight-bold",
            class: 'fadedblue--text',
            style: (_vm.$vuetify.breakpoint
              .smAndDown ?
              'font-size: 12px' :
              '')
          })]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-row', {
      staticStyle: {
        "margin-top": "3px"
      }
    }, [_c('v-col', {
      staticClass: "pt-0 cursor-pointer",
      attrs: {
        "md": "6",
        "cols": "11"
      }
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-skeleton-loader', {
      attrs: {
        "type": "image"
      }
    })], 1)], 1)], 1)], 1)
  }), 1)], 1) : (!_vm.loading && _vm.premiclasses.length < 1) ? _c('v-sheet', {
    staticClass: "mx-auto mt-5 text-center d-flex flex-column fill-height",
    attrs: {
      "color": "transparent",
      "width": _vm.$vuetify.breakpoint.smAndDown ?
        '80vw' :
        '400',
      "height": "50vh"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "width": "324",
      "height": "150",
      "src": require('@/assets/no_class.svg'),
      "contain": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "roboto-text font-weight-700"
  }, [_vm._v("\n                                Tidak ada data kelas\n                            ")])], 1) : (_vm.premiclasses.length > 0) ? _c('v-timeline', {
    staticStyle: {
      "min-height": "100%"
    },
    attrs: {
      "align-top": "",
      "dense": ""
    }
  }, _vm._l((_vm.premiclasses), function(item, index) {
    return _c('v-timeline-item', {
      key: index,
      attrs: {
        "color": item.statusLive ? '#50559F' : '#AFB6C9',
        "fill-dot": "",
        "icon": "mdi-circle-outline",
        "small": ""
      },
      scopedSlots: _vm._u([{
        key: "opposite",
        fn: function() {
          return [_c('span', {
            staticClass: "font-weight-bold",
            class: item.statusLive ?
              'blueple--text' :
              'fadedblue--text',
            style: (_vm.$vuetify.breakpoint.smAndDown ?
              'font-size: 12px' :
              '')
          }, [_vm._v(_vm._s(_vm.moment(item.startAt).format(
            "HH:mm"
          )))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-row', {
      staticStyle: {
        "margin-top": "3px"
      }
    }, [_c('v-col', {
      staticClass: "pt-0 cursor-pointer",
      attrs: {
        "md": "6",
        "cols": "11"
      }
    }, [_c('v-card', {
      style: (!item.statusLive ?
        'background-color:#FBFBFB; border-color: #EBEBEB' :
        ''),
      attrs: {
        "outlined": "",
        "color": item.statusLive ?
          '#50559F' :
          '',
        "dark": item.statusLive
      },
      on: {
        "click": function($event) {
          return _vm.checklive(item)
        }
      }
    }, [_c('v-card-text', [_c('div', {
      staticClass: "roboto-text font-weight-400",
      class: item.statusLive ?
        'monochrome--text' :
        'grey7--text',
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("\n                                                    " + _vm._s(item.subject) + "\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "roboto-text font-weight-700",
      class: item.statusLive ?
        'monochrome--text' :
        'grey7--text',
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                                                    " + _vm._s(item.name) + "\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "roboto-text font-weight-400",
      class: item.statusLive ?
        'monochrome--text' :
        'grey7--text',
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("\n                                                    " + _vm._s(item.teachers) + "\n                                                ")])])], 1)], 1)], 1)], 1)
  }), 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d70e958","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/omnilearning/components/LiveQuiz.vue
// module id = 1964
// module chunks = 1